import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../shared/services/user.service';
import {AlertService} from '../../shared/services/alert.service';
import {FileService} from '../../shared/services/file.service';
import {AppConstants} from '../../shared/constants/app-constant';

@Component({
    selector: 'app-setting',
    templateUrl: './setting.component.html',
    styleUrls: ['./setting.component.scss']
})
export class SettingComponent implements OnInit {
    panSubmitted: any = false;
    panSubmitting: any = false;
    panDetailForm: FormGroup;
    aadharSubmitted: any = false;
    aadharSubmitting: any = false;
    aadharDetailForm: FormGroup;
    bankSubmitted: any = false;
    bankSubmitting: any = false;
    bankAccountDetailForm: FormGroup;
    nomineeSubmitted: any = false;
    nomineeSubmitting: any = false;
    nomineeDetailForm: FormGroup;
    onFileChangedPAN: any;
    onFileChangedAadharFront: any;
    onFileChangedAadharBack: any;
    onFileChangedBankProof: any;
    docSubmittingPAN: any = false;
    docSubmittingAadharFront: any = false;
    docSubmittingAadharBack: any = false;
    docSubmittingBankProof: any = false;
    userData: any;
    imageBaseUrl: any = AppConstants.BUCKET_URL;
    selectedPAN: any;
    selectedAadharFront: any;
    selectedAadharBack: any;
    selectedBankProof: any;

    constructor(private fb: FormBuilder,
                private userService: UserService,
                private alertService: AlertService,
                private fileService: FileService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.panDetailForm = this.fb.group({
            'pan': ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9]{10}$')])]
        });
        this.aadharDetailForm = this.fb.group({
            'aadhar_no': ['', Validators.compose([Validators.required, Validators.pattern('^[0-9]{12}$')])]
        });
        this.bankAccountDetailForm = this.fb.group({
            'bank_account_holder_name': ['', Validators.required],
            'bank_account_no': ['', Validators.required],
            'bank_name': ['', Validators.required],
            'bank_branch': ['', Validators.required],
            'bank_ifsc': ['', Validators.required]
        });
        this.nomineeDetailForm = this.fb.group({
            'nominee_name': ['', Validators.required],
            'nominee_bank_name': [''],
            'nominee_account_no': [''],
            'nominee_ifsc': ['']
        });
        this.getUserDetail();
    }

    getUserDetail() {
        this.userService.selfDetail().subscribe(data => {
            if (data) {
                this.userData = data;
                this.patchPANDetail();
                this.patchAadharDetail();
                this.patchBankDetail();
                this.patchNomineeDetail();
            }
        });
    }

    patchPANDetail() {
        this.panDetailForm.patchValue({
           'pan': (this.userData && this.userData.pan) ? this.userData.pan : ''
        });
        this.selectedPAN = (this.userData && this.userData['pan_image']) ? this.userData['pan_image'] : '';
    }

    patchAadharDetail() {
        this.aadharDetailForm.patchValue({
            'aadhar_no': (this.userData && this.userData.aadhar_no) ? this.userData.aadhar_no : ''
        });
        this.selectedAadharFront = (this.userData && this.userData['aadhar_front_image']) ? this.userData['aadhar_front_image'] : '';
        this.selectedAadharBack = (this.userData && this.userData['aadhar_back_image']) ? this.userData['aadhar_back_image'] : '';
    }

    patchBankDetail() {
        this.bankAccountDetailForm.patchValue({
            'bank_account_holder_name': (this.userData && this.userData.bank_account_holder_name) ? this.userData.bank_account_holder_name : '',
            'bank_account_no': (this.userData && this.userData.bank_account_no) ? this.userData.bank_account_no : '',
            'bank_name': (this.userData && this.userData.bank_name) ? this.userData.bank_name : '',
            'bank_branch': (this.userData && this.userData.bank_branch) ? this.userData.bank_branch : '',
            'bank_ifsc': (this.userData && this.userData.bank_ifsc) ? this.userData.bank_ifsc : ''
        });
        this.selectedBankProof = (this.userData && this.userData['bank_passbook_cancelled_cheque_image']) ? this.userData['bank_passbook_cancelled_cheque_image'] : '';
    }

    patchNomineeDetail() {
        this.nomineeDetailForm.patchValue({
            'nominee_name': (this.userData && this.userData.nominee_name) ? this.userData.nominee_name : '',
            'nominee_bank_name': (this.userData && this.userData.nominee_bank_name) ? this.userData.nominee_bank_name : '',
            'nominee_account_no': (this.userData && this.userData.nominee_account_no) ? this.userData.nominee_account_no : '',
            'nominee_ifsc': (this.userData && this.userData.nominee_ifsc) ? this.userData.nominee_ifsc : '',
        });
    }

    updatePan() {
        this.panSubmitted = true;
        if (!this.panDetailForm.valid) {
            return;
        }
       /* if (!this.selectedPAN || !this.selectedPAN.id) {
            this.alertService.showErrors('Please upload PAN to submit PAN details');
            return;
        }*/
        if (this.panSubmitted) {
            const params = {
                'pan': (this.panDetailForm.value && this.panDetailForm.value.pan) ? this.panDetailForm.value.pan : '',
                'pan_image': (this.selectedPAN && this.selectedPAN.id) ? this.selectedPAN.id : ''
            };
            this.panSubmitting = true;
            this.userService.updatePAN(params).subscribe(data => {
                if (data) {
                    this.panSubmitting = false;
                    this.panSubmitted = false;
                    this.selectedPAN = undefined;
                    this.panDetailForm.reset();
                    this.panDetailForm.patchValue({
                        'pan': ''
                    });
                    this.getUserDetail();
                }
            }, error => {
                this.panSubmitting = false;
                this.panSubmitted = false;
            });
        }
    }

    updateAadhar() {
        this.aadharSubmitted = true;
        if (!this.aadharDetailForm.valid) {
            return;
        }
       /* if (!this.selectedAadharFront || !this.selectedAadharFront.id) {
            this.alertService.showErrors('Please upload Aadhar Front Image to submit Aadhar details');
            return;
        }
        if (!this.selectedAadharBack || !this.selectedAadharBack.id) {
            this.alertService.showErrors('Please upload Aadhar Back Image to submit Aadhar details');
            return;
        }*/
        if (this.aadharSubmitted) {
            const params = {
                'aadhar_no': (this.aadharDetailForm.value && this.aadharDetailForm.value.aadhar_no) ? this.aadharDetailForm.value.aadhar_no : '',
                'aadhar_front_image': (this.selectedAadharFront && this.selectedAadharFront.id) ? this.selectedAadharFront.id : '',
                'aadhar_back_image': (this.selectedAadharBack && this.selectedAadharBack.id) ? this.selectedAadharBack.id : ''
            };
            this.aadharSubmitting = true;
            this.userService.updateAadhar(params).subscribe(data => {
                if (data) {
                    this.aadharSubmitting = false;
                    this.aadharSubmitted = false;
                    this.selectedAadharFront = undefined;
                    this.selectedAadharBack = undefined;
                    this.aadharDetailForm.reset();
                    this.aadharDetailForm.patchValue({
                        'aadhar_no': ''
                    });
                    this.getUserDetail();
                }
            }, error => {
                this.aadharSubmitting = false;
                this.aadharSubmitted = false;
            });
        }
    }

    updateAccount() {
        this.bankSubmitted = true;
        if (!this.bankAccountDetailForm.valid) {
            return;
        }
        /*if (!this.selectedBankProof || !this.selectedBankProof.id) {
            this.alertService.showErrors('Please upload Bank Proof to submit Bank details');
            return;
        }*/
        if (this.bankSubmitted) {
            const params = {
                'bank_account_holder_name': (this.bankAccountDetailForm.value && this.bankAccountDetailForm.value.bank_account_holder_name) ? this.bankAccountDetailForm.value.bank_account_holder_name : '',
                'bank_account_no': (this.bankAccountDetailForm.value && this.bankAccountDetailForm.value.bank_account_no) ? this.bankAccountDetailForm.value.bank_account_no : '',
                'bank_name': (this.bankAccountDetailForm.value && this.bankAccountDetailForm.value.bank_name) ? this.bankAccountDetailForm.value.bank_name : '',
                'bank_branch': (this.bankAccountDetailForm.value && this.bankAccountDetailForm.value.bank_branch) ? this.bankAccountDetailForm.value.bank_branch : '',
                'bank_ifsc': (this.bankAccountDetailForm.value && this.bankAccountDetailForm.value.bank_ifsc) ? this.bankAccountDetailForm.value.bank_ifsc : '',
                'bank_passbook_cancelled_cheque_image': (this.selectedBankProof && this.selectedBankProof.id) ? this.selectedBankProof.id : '',
            };
            this.bankSubmitting = true;
            this.userService.updateBank(params).subscribe(data => {
                if (data) {
                    this.bankSubmitting = false;
                    this.bankSubmitted = false;
                    this.selectedBankProof = undefined;
                    this.bankAccountDetailForm.reset();
                    this.bankAccountDetailForm.patchValue({
                        'bank_account_holder_name': '',
                        'bank_account_no': '',
                        'bank_name': '',
                        'bank_branch': '',
                        'bank_ifsc': '',
                    });
                    this.getUserDetail();
                }
            }, error => {
                this.bankSubmitting = false;
                this.bankSubmitted = false;
            });
        }
    }

    updateNominee() {
        this.nomineeSubmitting = true;
        if (!this.nomineeDetailForm.valid) {
            return;
        }
        if (this.nomineeSubmitting) {
            const params = {
                'nominee_name': (this.nomineeDetailForm.value && this.nomineeDetailForm.value.nominee_name) ? this.nomineeDetailForm.value.nominee_name : '',
                'nominee_bank_name': (this.nomineeDetailForm.value && this.nomineeDetailForm.value.nominee_bank_name) ? this.nomineeDetailForm.value.nominee_bank_name : '',
                'nominee_account_no': (this.nomineeDetailForm.value && this.nomineeDetailForm.value.nominee_account_no) ? this.nomineeDetailForm.value.nominee_account_no : '',
                'nominee_ifsc': (this.nomineeDetailForm.value && this.nomineeDetailForm.value.nominee_ifsc) ? this.nomineeDetailForm.value.nominee_ifsc : '',
            };
            this.nomineeSubmitted = true;
            this.userService.updateNominee(params).subscribe(data => {
                if (data) {
                    this.nomineeSubmitted = false;
                    this.nomineeSubmitting = false;
                    this.nomineeDetailForm.reset();
                    this.nomineeDetailForm.patchValue({
                        'nominee_name': '',
                        'nominee_bank_name': '',
                        'nominee_account_no': '',
                        'nominee_ifsc': ''
                    });
                    this.getUserDetail();
                }
            }, error => {
                this.nomineeSubmitting = false;
                this.nomineeSubmitted = false;
            });
        }
    }

    onFileChange(e, type) {
        if (type === 'PAN_CARD') {
            this.onFileChangedPAN = e;
            this.docSubmittingPAN = true;
            this.fileService.fileUpload({
                'type': 'PAN_CARD',
                'fileType': 'NORMAL'
            }, this.onFileChangedPAN).subscribe(data => {
                this.selectedPAN = data['data'];
                this.docSubmittingPAN = false;
                this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
            }, error => {
                this.docSubmittingPAN = false;
                this.alertService.showErrors('Something went wrong, please try again');
            });
        } else if (type === 'AADHAR_CARD_FRONT') {
            this.onFileChangedAadharFront = e;
            this.docSubmittingAadharFront = true;
            this.fileService.fileUpload({
                'type': 'AADHAR_CARD_FRONT',
                'fileType': 'NORMAL'
            }, this.onFileChangedAadharFront).subscribe(data => {
                this.selectedAadharFront = data['data'];
                this.docSubmittingAadharFront = false;
                this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
            }, error => {
                this.docSubmittingAadharFront = false;
                this.alertService.showErrors('Something went wrong, please try again');
            });
        } else if (type === 'AADHAR_CARD_BACK') {
            this.onFileChangedAadharBack = e;
            this.docSubmittingAadharBack = true;
            this.fileService.fileUpload({
                'type': 'AADHAR_CARD_BACK',
                'fileType': 'NORMAL'
            }, this.onFileChangedAadharBack).subscribe(data => {
                this.selectedAadharBack = data['data'];
                this.docSubmittingAadharBack = false;
                this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
            }, error => {
                this.docSubmittingAadharBack = false;
                this.alertService.showErrors('Something went wrong, please try again');
            });
        } else if (type === 'BANK_PROOF') {
            this.onFileChangedBankProof = e;
            this.docSubmittingBankProof = true;
            this.fileService.fileUpload({
                'type': 'BANK_PROOF',
                'fileType': 'NORMAL'
            }, this.onFileChangedBankProof).subscribe(data => {
                this.selectedBankProof = data['data'];
                this.docSubmittingBankProof = false;
                this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
            }, error => {
                this.docSubmittingBankProof = false;
                this.alertService.showErrors('Something went wrong, please try again');
            });
        }
    }

    openExternalUrl(url) {
        window.open(url, '_blank');
    }
}
